import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { StarIcon } from "@/shared/icons";

type Props = {
  level: number;
  className?: string;
};

const starsArray = new Array(5).fill(null);

export default function HudWantedLevel({ level, className }: Props) {
  return (
    <div
      className={cn(
        "flex items-center gap-0.5",
        level > 0 ? "showWantedLevel" : "hideWantedLevel",
        className,
      )}
    >
      {starsArray.map((_, index) => (
        <StarIcon
          size={20}
          key={`${index + index}`}
          className={clsx(
            index < level ? "text-white" : "text-white/50",
            level === index + 1 ? "blinkLevel" : "",
          )}
        />
      ))}
    </div>
  );
}
